import { put, takeEvery } from "redux-saga/effects";
import * as types from "../types";
import { ROLE_ACCESS } from "../../utils/Utils";
import { loginRequestForUser, getUserDetails,getLoggingInUserInfo } from "../agent";
import { jwtDecode } from "jwt-decode";

function* userLoginSaga(action) {
  if (action.payload.email && action.payload.password) {
    try {
      let payloadUpdated = {
        emailId: action.payload.email,
        password: action.payload.password,
        gRecaptchaResponse:action.payload.gRecaptchaResponse
      };
      yield put({
        type: types.SET_LOADER,
        payload:true
      });
      let responseLogin = yield loginRequestForUser(payloadUpdated);
      console.log("login response", responseLogin);
      let token = responseLogin.data.token;
      const decoded = jwtDecode(token);


      // let userDetails = yield getLoggingInUserInfo({token:responseLogin.data.token});
      let userDetails = decoded.userDetails

      if(userDetails){
        yield put({
          type: types.USER_LOGIN_SUCCESS,
          payload: {token:responseLogin.data.token,userData:userDetails}
        });
        sessionStorage.setItem('token',responseLogin.data.token);
        sessionStorage.setItem('emailId',action.payload.email);
      }
      // if(userDetails.status === 200){
      //   yield put({
      //     type: types.USER_LOGIN_SUCCESS,
      //     payload: {token:responseLogin.data.token,userData:userDetails.data}
      //   });
      //   sessionStorage.setItem('token',responseLogin.data.token);
      //   sessionStorage.setItem('emailId',action.payload.email);
      // }
      else{
        yield put({
          type: types.USER_LOGIN_FAILED,
        });
      }
    } catch (err) {
      yield put({
        type: types.USER_LOGIN_FAILED,
      });
    }
    finally{
      yield put({
        type: types.SET_LOADER,
        payload:false
      });
    }
  } 
}

function* getUserDetailsSaga(action) {
  try {
    yield put({
      type: types.SET_LOADER,
      payload:true
    });
    // let userDetails = yield getLoggingInUserInfo(action.payload);
    let token = action.payload.token;
    const decoded = jwtDecode(token);

    let  userDetails = decoded.userDetails
    if(userDetails){
      yield put({
        type: types.USER_LOGIN_SUCCESS,
        payload:{userData:userDetails,token:action.payload.token}
      });
      yield put({
        type: types.SET_LOADER,
        payload:false
      });
    }
    else{
      yield put({
        type: types.USER_LOGIN_FAILED,
      });
    }
    
  } catch (err) {
    yield put({
      type: types.USER_LOGOUT,
    });
  }
  finally{
    yield put({
      type: types.SET_LOADER,
      payload:false
    });

  }
}

function* userLogoutSaga(action) {
try{
  sessionStorage.clear();
  yield put({
    type: types.USER_LOGOUT_SUCCESS,
  });
}
catch(err) {
  yield put({
    type: types.USER_LOGOUT_FAILED,
  });
}
}


function* getUser() {
  yield takeEvery(types.USER_LOGIN, userLoginSaga);
  yield takeEvery(types.GET_USER_DETAILS, getUserDetailsSaga);
  yield takeEvery(types.USER_LOGOUT, userLogoutSaga);
}

export default getUser;
